// Meta Pixel Event Tracking Utility
import TagManager from 'react-gtm-module';


interface PageViewEvent {
  user_id: string;
  page_path: string;
}

interface RubyPurchasedEvent {
  user_id: string;
  purchase_amount: number;
  currency: string;
}

interface CompleteRegistrationEvent {
  user_id: string;
}

interface GameInitiationEvent {
  user_id: string;
  game_type: 'Wheel Spin' | 'Quickfire' | 'Trader' | 'Squares';
}

interface PlayTraderSquaresEvent {
  user_id: string;
  outcome: 'win' | 'loss';
}

// Track page view
export const trackPageView = (data: PageViewEvent) => {
    TagManager.dataLayer({
        dataLayer: {
            event: 'page_view',
            user_id: data.user_id,
            page_path: data.page_path
        }
    })
};

// Track ruby purchase
export const trackRubyPurchased = (data: RubyPurchasedEvent) => {
    TagManager.dataLayer({
        dataLayer: {
            event: 'ruby_purchased',
            user_id: data.user_id,
            purchase_amount: data.purchase_amount,
            currency: data.currency
        }
    });
};

// Track registration completion
export const trackCompleteRegistration = (data: CompleteRegistrationEvent) => {
    TagManager.dataLayer({
        dataLayer: {
            event: 'CompleteRegistration',
            user_id: data.user_id
        }
    });
};

// Track game initiation
export const trackGameInitiation = (data: GameInitiationEvent) => {
    TagManager.dataLayer({
        dataLayer: {
            event: 'game_initiation',
            user_id: data.user_id,
            game_type: data.game_type
        }
    });
};

// Track trader/squares game completion
export const trackPlayTraderSquares = (data: PlayTraderSquaresEvent) => {
    TagManager.dataLayer({
        dataLayer: {
            event: 'play_trader_squares',
            user_id: data.user_id,
            outcome: data.outcome
        }
    });
};
